import { jsx as _jsx } from "react/jsx-runtime";
import { IntlProvider } from 'react-intl';
/* eslint-disable react/prop-types */
import { translationsMap } from './localization/translations-map';
export const getTranslationsImportPath = (language, repo) => {
    if (repo in translationsMap) {
        const translationsLanguage = translationsMap[repo];
        if (language in translationsLanguage) {
            return translationsLanguage[language];
        }
        throw new Error(`No ${language} language found for repo: ${repo}`);
    }
    throw new Error(`No ${repo} repo found in translations map`);
};
export const TranslationsProvider = ({ children, language, render, translations, }) => (
// TODO: We need to upgrade to React 18
// @ts-ignore
_jsx(IntlProvider, { locale: language, messages: translations, children: render(children) }));
//# sourceMappingURL=translations-context-provider.js.map